// extracted by mini-css-extract-plugin
export default {"qrReaderContainer":"XBXXtrkvemyqit2G7DLX"};